(function(){
  "use strict";
  var containers=[
    {value:"scepter1020",label:"Scepter 10L / 20L",desc:"Non-military water container"},
    {value:"scepter5",label:"Scepter 5-gallon potable",desc:"Potable water can, SKU #04933"},
    {value:"lci",label:"LCI 5-gallon military",desc:"U.S. government-style container"},
    {value:"rotopax",label:"RotoPax",desc:"Water container, not fuel container"},
    {value:"aqua",label:"Reliance Aqua-Tainer"},
    {value:"rhino",label:"Reliance Rhino-Pak"},
    {value:"igloo",label:"Igloo water cooler"},
    {value:"coleman",label:"Coleman water jug"}
  ];
  function escapeHtml(value){
    return String(value==null?"":value).replace(/[&<>"']/g,function(ch){
      return {"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[ch];
    });
  }
  function setup(root){
    if(root.getAttribute("data-fcusa-ready")==="yes")return;
    var source=root.querySelector("[data-fcusa-products]");
    var app=root.querySelector("[data-fcusa-app]");
    var stage=root.querySelector("[data-fcusa-camp-stage]");
    var flow=root.querySelector("[data-fcusa-flow]");
    if(!source||!app||!stage||!flow)return;
    var products=[];
    try{products=JSON.parse(source.textContent||"[]");}
    catch(e){app.textContent="The Gear Finder is temporarily unavailable. Please browse our collections.";return;}
    var byRoute={};
    products.forEach(function(p){if(p&&p.route)byRoute[p.route]=p;});
    var campSource=root.querySelector("[data-fcusa-camp-products]");
    var campProducts=[];
    try{campProducts=JSON.parse(campSource?campSource.textContent||"[]":"[]");}
    catch(e){campProducts=[];}
    var dieselSource=root.querySelector("[data-fcusa-diesel-products]");
    var dieselProducts=[];
    try{dieselProducts=JSON.parse(dieselSource?dieselSource.textContent||"[]":"[]");}
    catch(e){dieselProducts=[];}
    var state={step:1,category:"",container:"",pump:"",can:"",parts:"",dieselType:"",fuel:"",vent:"",tentFit:"",dieselChoice:"",campType:"",campFit:"",campChoice:""};
    function choices(key,items,wide){
      return '<div class="fcusa-finder__choices'+(wide?' fcusa-finder__choices--wide':'')+'" role="group" aria-label="Available choices">'+items.map(function(item){
        var selected=state[key]===item.value;
        return '<button type="button" class="fcusa-finder__option" data-choice="'+escapeHtml(key)+'" data-value="'+escapeHtml(item.value)+'" aria-pressed="'+(selected?"true":"false")+'">'+
          (item.icon?'<span class="fcusa-finder__choice-icon" aria-hidden="true">'+escapeHtml(item.icon)+'</span>':'')+
          '<strong>'+escapeHtml(item.label)+'</strong>'+
          (item.desc?'<small>'+escapeHtml(item.desc)+'</small>':'')+'</button>';
      }).join("")+'</div>';
    }
    function campProductsFor(category){
      return campProducts.filter(function(product){return product&&product.category===category;});
    }
    function campChoiceItems(category){
      return campProductsFor(category).map(function(product){
        return {
          value:product.handle,
          label:product.title,
          desc:product.price||""
        };
      });
    }
    function campStepContent(){
      var title="",helper="",body="";
      if(state.step===1){
        title="Which mount category are you shopping for?";
        helper="Choose the adapter category that matches your setup.";
        var categories=[
          {value:"devos",label:"Devos LightRanger mount adapter",desc:"For the LightRanger 1200 and 2000"},
          {value:"jk",label:"Jeep Wrangler JK/JKU mount",desc:"For 2007-2018 JK and JKU models"}
        ].filter(function(item){return campProductsFor(item.value).length>0;});
        body=categories.length?choices("campType",categories,true):'<p class="fcusa-finder__resultnote">No matching products are currently published. Contact FireCrateUSA for help.</p>';
      }else if(state.step===2&&state.campType==="devos"){
        title="Which Devos mount option fits your setup?";
        helper="Choose the included mounting option that best suits where you use your LightRanger.";
        body=choices("campChoice",campChoiceItems("devos"),true);
      }else if(state.step===2&&state.campType==="jk"){
        title="Which Jeep Wrangler do you have?";
        helper="This mount is listed for 2007-2018 Jeep Wrangler JK and JKU models.";
        body=choices("campFit",[
          {value:"yes",label:"2007-2018 Wrangler JK or JKU"},
          {value:"no",label:"A different model or year"},
          {value:"unsure",label:"I'm not sure"}
        ],true);
      }else if(state.step===3&&state.campFit==="yes"){
        title="Which JK/JKU mount option do you need?";
        helper="Choose from currently published products in this category.";
        body=choices("campChoice",campChoiceItems(state.campType),true);
      }
      return {title:title,helper:helper,body:body};
    }
    function campProductNote(product){
      if(state.campType==="devos"){
        if(/superclamp/i.test(product.title))return "Includes the 1/4-20 adapter and adjustable SuperClamp arm for awning poles, grab handles, and other suitable surfaces.";
        if(/tripod/i.test(product.title))return "Includes the 1/4-20 adapter and tabletop mini tripod for tables, counters, and other level surfaces.";
        return "Includes the 1/4-20 adapter for a compatible Devos LightRanger 1200 or 2000. Mounting hardware is not included.";
      }
      if(state.campType==="jk")return "Listed for 2007-2018 Jeep Wrangler JK and JKU models. Confirm your vehicle year and generation before ordering.";
      return "Review the product page for exact compatibility and included components.";
    }
    function stepContent(){
      var title="",helper="",body="";
      if(state.category==="camp")return campStepContent();
      if(state.step===1){
        title="What are you working on?";
        helper="Choose the FireCrateUSA product category that matches your setup.";
        body=choices("category",[
          {value:"fire",label:"Portable fire pit",desc:"Build around a 50-cal ammo can",icon:"♨"},
          {value:"water",label:"Water pump setup",desc:"Find a container-specific adapter or full kit",icon:"◉"},
          {value:"diesel",label:"Diesel heater accessories",desc:"Fuel and rooftop-tent heater accessories",icon:"◆"}
        ],true);
      }else if(state.step===2){
        if(state.category==="water"){
          title="Which container do you have?";
          helper="Select the exact water container family. Similar-looking containers aren't necessarily interchangeable.";
          body=choices("container",containers,false);
        }else if(state.category==="fire"){
          title="Do you already have an ammo can?";
          helper="This builder is for a compatible 50-cal ammo can fire pit. Confirm can compatibility before ordering.";
          body=choices("can",[
            {value:"yes",label:"Yes, I already own the can"},
            {value:"no",label:"No, I need a complete setup"}
          ],true);
        }else{
          title="Which diesel heater accessory do you need?";
          helper="Tell us which accessory you're shopping for.";
          var dieselTypes=[
            {value:"fuel",label:"Fuel-can adapter",desc:"Connect a compatible fuel container to your diesel heater"},
            {value:"tent",label:"Rooftop-tent passthrough",desc:"A zipper-track port for heater air ducting"}
          ].filter(function(item){return item.value!=="tent"||dieselProducts.length>0;});
          body=choices("dieselType",dieselTypes,true);
        }
      }else if(state.step===3){
        if(state.category==="water"){
          title="Do you already own a compatible pump?";
          helper="FireCrateUSA adapter-only options require a compatible non-threaded rechargeable pump connection. Having just any pump is not enough.";
          body=choices("pump",[
            {value:"yes",label:"Yes, I have a compatible pump",desc:"Show me the adapter-only option"},
            {value:"no",label:"No, I need the pump too",desc:"Show me the complete rechargeable water pump kit"},
            {value:"unsure",label:"I'm not sure my pump fits",desc:"Help me verify before buying"}
          ],true);
        }else if(state.category==="fire"){
          if(state.can==="no"){
            title="You need the ammo can as well.";
            helper="The Complete Fire Pit Kit is the relevant starting point. The product page has the current configuration options.";
            body='<p class="fcusa-finder__resultnote">The final product page shows what is included and your available configuration choices.</p>';
          }else{
            title="Do you have the propane components?";
            helper="Do you already have a compatible propane regulator and hose for the burner?";
            body=choices("parts",[
              {value:"yes",label:"Yes, I have compatible parts",desc:"I only need the FireCrateUSA burner"},
              {value:"no",label:"No, I need a regulator and hose",desc:"Include the propane components"},
              {value:"unsure",label:"I'm not sure they're compatible",desc:"Help me check first"}
            ],true);
          }
        }else if(state.dieselType==="tent"){
          title="Will this fit your rooftop tent setup?";
          helper="This adapter mounts in your rooftop tent's door or window zipper opening and works with compatible 75mm heater vent hardware. Check your opening before ordering.";
          body=choices("tentFit",[
            {value:"yes",label:"Yes, that is the accessory I need",desc:"View the rooftop-tent passthrough adapter"},
            {value:"unsure",label:"I'm unsure about my zipper opening",desc:"Help me check the tent and ducting first"},
            {value:"no",label:"No, that's not my setup",desc:"Ask about a compatible alternative"}
          ],true);
        }else{
          title="Which fuel can are you using?";
          helper="Select your fuel container to see the available FireCrateUSA adapters.";
          body=choices("fuel",[
            {value:"rotopax",label:"RotoPax fuel container",desc:"Standard or Enhanced adapter, depending on venting"},
            {value:"longhaul",label:"Compatible Long-Haul fuel can",desc:"Uses the fuel can's built-in factory vent"}
          ],true);
        }
      }else if(state.step===4 && state.category==="diesel" && state.dieselType==="tent" && state.tentFit==="yes"){
        title="Which rooftop-tent adapter do you need?";
        helper="Choose from currently published rooftop-tent adapters in Diesel Heater Accessories.";
        body=dieselProducts.length?choices("dieselChoice",dieselProducts.map(function(product){
          return {value:product.handle,label:product.title,desc:product.price||""};
        }),true):'<p class="fcusa-finder__resultnote">No rooftop-tent adapters are currently published in Diesel Heater Accessories.</p>';
      }else if(state.step===4 && state.category==="diesel" && state.dieselType==="fuel" && state.fuel==="rotopax"){
        title="Does your RotoPax setup have suitable venting?";
        helper="A sealed fuel can must not be used without appropriate venting while fuel is being drawn. If you are unsure, don't guess.";
        body=choices("vent",[
          {value:"yes",label:"Yes, I have verified existing venting",desc:"Standard may be suitable for my setup"},
          {value:"no",label:"No, I need a built-in manual vent",desc:"Show the Enhanced adapter"},
          {value:"unsure",label:"I don't know",desc:"Ask FireCrateUSA to verify my setup"}
        ],true);
      }
      return {title:title,helper:helper,body:body};
    }
    function showCamp(){
      state={step:1,category:"",container:"",pump:"",can:"",parts:"",dieselType:"",fuel:"",vent:"",tentFit:"",dieselChoice:"",campType:"",campFit:"",campChoice:""};
      stage.hidden=false;
      flow.hidden=true;
      stage.scrollIntoView({behavior:"smooth",block:"start"});
      var first=stage.querySelector("[data-fcusa-camp-select]");
      if(first)first.focus({preventScroll:true});
    }
    function enterCampRoute(which){
      state={step:1,category:"",container:"",pump:"",can:"",parts:"",dieselType:"",fuel:"",vent:"",tentFit:"",dieselChoice:"",campType:"",campFit:"",campChoice:""};
      if(which==="camp"){state.category="camp";state.step=1;}
      else if(which==="water"||which==="fire"){state.category=which;state.step=2;}
      else if(which==="diesel"||which==="fuel"){state.category="diesel";state.step=2;}
      else return;
      stage.hidden=true;
      flow.hidden=false;
      render(true);
      flow.scrollIntoView({behavior:"smooth",block:"start"});
    }
    stage.addEventListener("click",function(event){
      var clicked=event.target.closest("[data-fcusa-camp-select]");
      if(clicked&&stage.contains(clicked))enterCampRoute(clicked.getAttribute("data-fcusa-camp-select"));
    });
    function resultStep(){
      if(state.category==="camp")return state.campType==="jk"&&state.campFit==="yes"?4:3;
      if(state.category==="fire" && state.can==="no")return 3;
      return (state.category==="diesel"&&state.dieselType==="fuel"&&state.fuel==="rotopax")||(state.category==="diesel"&&state.dieselType==="tent"&&state.tentFit==="yes")?5:4;
    }
    function isReady(){
      if(state.category==="camp"){
        if(state.step===1)return !!state.campType;
        if(state.step===2)return state.campType==="devos"?!!state.campChoice:!!state.campFit;
        if(state.step===3)return state.campFit==="yes"?!!state.campChoice:true;
      }
      if(state.step===1)return !!state.category;
      if(state.step===2)return state.category==="water"?!!state.container:state.category==="fire"?!!state.can:!!state.dieselType;
      if(state.step===3){
        if(state.category==="water")return !!state.pump;
        if(state.category==="fire")return state.can==="no"||!!state.parts;
        return state.dieselType==="tent"?!!state.tentFit:!!state.fuel;
      }
      if(state.step===4 && resultStep()===5)return state.dieselType==="tent"?!!state.dieselChoice:!!state.vent;
      return true;
    }
    function getOutcome(){
      var key="",note="",warning="",match=null;
      if(state.category==="camp"){
        if(state.campType==="jk"&&state.campFit!=="yes"){
          warning="This mount is listed for 2007-2018 Jeep Wrangler JK and JKU models. Contact FireCrateUSA if your vehicle is different.";
        }else if(!state.campChoice){
          warning="Choose a product option so we can show the right match.";
        }else{
          match=campProducts.find(function(product){return product.category===state.campType&&product.handle===state.campChoice;});
          if(!match)warning="That product is no longer available in this category. Browse current FireCrateUSA products or contact us for help.";
          else note=campProductNote(match);
        }
      }else if(state.category==="water"){
        if(state.pump==="unsure")warning="Before choosing an adapter-only product, confirm that your pump has a compatible non-threaded connection. Send FireCrateUSA your pump details for help.";
        else{
          key="water:"+state.container+":"+(state.pump==="yes"?"adapter":"kit");
          note=state.pump==="yes"?"Adapter only. Rechargeable pump, hose, spout and water container are not included.":"Includes the container-specific adapter and rechargeable faucet components. Water container sold separately.";
        }
      }else if(state.category==="fire"){
        if(state.can==="no"){key="fire:complete";note="Includes the 50-cal ammo can, FireCrateUSA burner, 20 PSI regulator with propane hose, and lighter. Review configuration choices on the product page.";}
        else if(state.parts==="yes"){key="fire:burner";note="Burner only. You supply the compatible 50-cal can and propane components.";}
        else if(state.parts==="no"){key="fire:byoc";note="Bring your own compatible 50-cal ammo can. Includes the burner, regulator with hose, and lighter.";}
        else warning="Verify the compatibility of your existing regulator, hose, and ammo can before choosing a burner-only setup.";
      }else if(state.category==="diesel"){
        if(state.dieselType==="tent"){
          if(state.tentFit==="yes"){
            match=dieselProducts.find(function(product){return product.handle===state.dieselChoice;});
            if(!match)warning="Choose a rooftop-tent adapter currently listed in Diesel Heater Accessories.";
            else note="Designed for a suitable rooftop-tent zipper opening and compatible 75 mm heater vent hardware. Vent and ducting are not included.";
          }
          else warning=state.tentFit==="no"?"This adapter may not fit your tent setup. Get in touch and we can help find an option that works.":"Not sure about your tent opening or vent size? Send us a photo or measurements and we can help check compatibility.";
        }else if(state.fuel==="longhaul"){key="diesel:longhaul";note="For a compatible Long-Haul fuel can with its own built-in vent. Follow all container and heater operating instructions.";}
        else if(state.vent==="yes"){key="diesel:standard";note="Non-vented RotoPax adapter. Use only with a verified suitable existing venting solution. If you need manual integrated vent control, review the Enhanced option.";}
        else if(state.vent==="no"){key="diesel:enhanced";note="RotoPax adapter with manually operated vent. The vent must be opened as required during heater operation and handled according to the fuel-container instructions.";}
        else warning="Fuel-can venting is safety-critical. Ask FireCrateUSA to check your fuel can and current venting setup before you choose an adapter.";
      }
      return {key:key,note:note,warning:warning,product:state.category==="diesel"&&state.dieselType==="tent"?match:(match||byRoute[key])};
    }
    function resultHtml(){
      var outcome=getOutcome(),p=outcome.product;
      if(outcome.warning){
        return '<p class="fcusa-finder__resultbadge">FITMENT CHECK REQUIRED</p>'+
          '<h3 class="fcusa-finder__question" tabindex="-1" data-fcusa-focus>Need help checking fit?</h3>'+
          '<p class="fcusa-finder__resultnote">'+escapeHtml(outcome.warning)+'</p>'+
          '<div class="fcusa-finder__resultbuttons"><a class="fcusa-finder__btn fcusa-finder__btn--primary" href="/pages/contact">Contact FireCrateUSA ↗</a></div>';
      }
      if(!p){
        return '<p class="fcusa-finder__resultbadge">PRODUCT MAPPING NEEDS REVIEW</p>'+
          '<h3 class="fcusa-finder__question" tabindex="-1" data-fcusa-focus>We need to confirm this match.</h3>'+
          '<p class="fcusa-finder__resultnote">The correct Shopify product was not configured for this route. No alternative will be substituted.</p>'+
          '<div class="fcusa-finder__resultbuttons"><a class="fcusa-finder__btn fcusa-finder__btn--primary" href="/pages/contact">Ask FireCrateUSA ↗</a></div>';
      }
      var img=p.image?'<img class="fcusa-finder__product-image" src="'+escapeHtml(p.image)+'" alt="'+escapeHtml(p.alt||p.title)+'" loading="lazy" width="114" height="114">':'<span class="fcusa-finder__product-image fcusa-finder__product-placeholder" aria-hidden="true"></span>';
      return '<p class="fcusa-finder__resultbadge">YOUR FIRECRATEUSA MATCH</p>'+
        '<h3 class="fcusa-finder__question" tabindex="-1" data-fcusa-focus>Here’s the option that fits your answers.</h3>'+
        '<div class="fcusa-finder__product">'+img+'<div><h4>'+escapeHtml(p.title)+'</h4><div class="fcusa-finder__price">'+escapeHtml(p.price)+'</div>'+
        '</div></div>'+
        '<p class="fcusa-finder__resultnote">'+escapeHtml(outcome.note)+'</p>'+
        '<div class="fcusa-finder__resultbuttons"><a class="fcusa-finder__btn fcusa-finder__btn--primary" href="'+escapeHtml(p.url)+'">Review product details ↗</a></div>';
    }
    function render(autofocus){
      var step=state.step,total=resultStep(),last=step===total,offset=(state.category==="diesel"&&state.dieselType)?1:0,displayStep=step-offset,displayTotal=total-offset;
      var markup='<div class="fcusa-finder__progressbar" aria-label="Progress: step '+displayStep+' of '+displayTotal+'">';
      for(var i=1;i<=displayTotal;i++)markup+='<span class="'+(i<=displayStep?'is-active':'')+'"></span>';
      markup+='</div><div class="fcusa-finder__stepmeta"><span>STEP '+displayStep+' / '+displayTotal+'</span><em>'+escapeHtml(last?"Your recommendation":"Find your fit")+'</em></div>';
      if(last){markup+='<div aria-live="polite">'+resultHtml()+'</div>';}
      else{
        var screen=stepContent();
        markup+='<h3 class="fcusa-finder__question" tabindex="-1" data-fcusa-focus>'+escapeHtml(screen.title)+'</h3>'+
          '<p class="fcusa-finder__helper">'+escapeHtml(screen.helper)+'</p>'+screen.body;
      }
      markup+='<div class="fcusa-finder__controls">';
      if(step===1)markup+='<span aria-hidden="true"></span>';
      else markup+='<button type="button" class="fcusa-finder__btn fcusa-finder__btn--back" data-fcusa-back>← Back</button>';
      if(!last&&(!screen||screen.body.indexOf('data-choice=')===-1))markup+='<button type="button" class="fcusa-finder__btn fcusa-finder__btn--primary" data-fcusa-next '+(isReady()?'':'disabled')+'>Continue →</button>';
      else markup+='<button type="button" class="fcusa-finder__btn fcusa-finder__btn--back" data-fcusa-restart>Start over ↺</button>';
      markup+='</div>';
      if(state.category==="diesel"){
        if(state.dieselType==="tent")markup+='<p class="fcusa-finder__safety">Follow the heater and tent manufacturers’ installation guidance. Never route heater exhaust into a tent.</p>';
        else markup+='<p class="fcusa-finder__safety">Always follow the fuel-container and diesel-heater manufacturers’ requirements for fuel handling, venting, safe use, and transport.</p>';
      }else if(state.category==="fire")markup+='<p class="fcusa-finder__safety">Follow the product installation guidance and all applicable propane and fire-safety rules. A propane fire pit is not automatically permitted during fire restrictions.</p>';
      else if(state.category==="water")markup+='<p class="fcusa-finder__safety">Check your exact container model and the pump connection before ordering an adapter-only option.</p>';
      app.innerHTML=markup;
      if(autofocus){var target=app.querySelector("[data-fcusa-focus]");if(target)target.focus({preventScroll:true});}
    }
    app.addEventListener("click",function(event){
      var choice=event.target.closest("[data-choice]");
      if(choice&&app.contains(choice)){
        var key=choice.getAttribute("data-choice"),value=choice.getAttribute("data-value");
        if(!Object.prototype.hasOwnProperty.call(state,key))return;
        if(state[key]!==value){
          if(key==="category"){state.container="";state.pump="";state.can="";state.parts="";state.dieselType="";state.fuel="";state.vent="";state.tentFit="";state.dieselChoice="";state.campType="";state.campFit="";state.campChoice="";}
          if(key==="dieselType"){state.fuel="";state.vent="";state.tentFit="";state.dieselChoice="";}
          if(key==="tentFit")state.dieselChoice="";
          if(key==="campType"){state.campFit="";state.campChoice="";}
          if(key==="campFit")state.campChoice="";
          if(key==="fuel")state.vent="";
          if(key==="container")state.pump="";
          if(key==="can")state.parts="";
        }
        state[key]=value;
        state.step=Math.min(resultStep(),state.step+1);
        render(true);
        var target=app.querySelector('[data-choice="'+key+'"][data-value="'+value+'"]');
        if(target)target.focus({preventScroll:true});
        return;
      }
      if(event.target.closest("[data-fcusa-next]")&&isReady()){
        state.step=Math.min(resultStep(),state.step+1);render(true);return;
      }
      if(event.target.closest("[data-fcusa-back]")){
        if(state.step===2&&state.category!=="camp"){
          showCamp();return;
        }
        state.step=Math.max(1,state.step-1);render(true);return;
      }
      if(event.target.closest("[data-fcusa-restart]")){
        showCamp();return;
      }
    });
    root.setAttribute("data-fcusa-ready","yes");
    stage.hidden=false;
    flow.hidden=true;
  }
  function init(context){
    var scope=context||document;
    if(scope.matches&&scope.matches("[data-fcusa-finder]"))setup(scope);
    scope.querySelectorAll("[data-fcusa-finder]").forEach(setup);
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",function(){init(document);});
  else init(document);
  document.addEventListener("shopify:section:load",function(event){init(event.target);});
})();